<!--<c-footer>-->
    <div style="font-size: 0.8em;">
      <a href="https://www.genailia.com/" target="_blank">Genailia</a>
      <span> &copy; 2024</span> - GenZ Technologies
    </div>
  
<!--</c-footer>-->
